import {Component} from 'react';
import h from 'react-hyperscript';
import {h4, p} from 'Components/Typography/Typography';
import BasicCard from 'Components/Cards/BasicCard';

import {formatDateLong} from 'Src/utils/utils';
import UpdateProductWindow from '../UpdateProductWindow/UpdateProductWindow';
import AddToCalendar from 'Components/Buttons/AddToCalendar';

class NoReportState extends Component {
  sanitize(string) {
    const nextSurveyDate = this.props.nextSurveyDate;
    const regex = /^\d{4}-\d{2}-\d{2}$/g;
    const isSimpleDate = regex.test(nextSurveyDate);

    const preText = isSimpleDate ? 'on' : 'in';
    const dateString = isSimpleDate ?
      formatDateLong(nextSurveyDate) :
      nextSurveyDate;

    return string
        .replace('{{next_survey_date}}', dateString)
        .replace('{{inOrOn}}', preText);
  }

  startDate() {
    return new Date(this.props.nextSurveyDate)
        .toISOString().replace(/-|:|\.\d\d\d/g, '');
  }

  render() {
    return h(
        BasicCard,
        {
          type: 'basic',
          className: 'report-overview__status status--no-report flex',
          id: `report-overview--${this.props.content.statusId}`,
        },
        h('div', null, [
          h(
              h4,
              {
                className: 'padding-bottom--micro',
              },
              `${this.sanitize(this.props.content.title)}`
          ),
          h(
              p,
              {
                className: 'text--grey padding-bottom--md-2',
              },
              this.sanitize(this.props.content.subtitle)
          ),
          h('div', {
            className: 'flex flex--wrap',
          }, [
            h(AddToCalendar, {
              title: 'Next Transformation Report',
              date: this.startDate(),
            }),
            this.props.userStatus.admin_level === 'Admin' ?
            h(UpdateProductWindow, {
              googleUser: this.props.googleUser,
              csrf: this.props.csrf,
              idToken: this.props.idToken,
              userStatus: this.props.userStatus,
            }) : null,
          ]),
        ])
    );
  }
}

export default NoReportState;
